package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2025_04_05_Day_1
import com.veldekar.components.logs.Log_2025_04_05_Day_2
import com.veldekar.components.logs.Log_2025_04_05_Day_3
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2025-04-05")
@Composable
public fun Log_2025_04_05(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Escalation",
        ogTitle = "Escalation",
        date = LocalDate(2_025, 4, 5),
        ogDescription = "The heroes have discovered that Veldekar is filled with fire resistant and even fire immune enemies. Now the dungeon master sends a golem to attack the heroes who is not just immune to damage from fire magic but is actually healed by it.",
        ogImage = "images/TheKeyOfKarzak.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
        ogImageAlt = "A pink 8-pointed star on a black background with the text 'The Key of Karzak'.",
    ) {
        SessionDayHeader(dayId = "newgrowth-85", dateString = "Newgrowth 85")
        Log_2025_04_05_Day_1()
        SessionDayHeader(dayId = "newgrowth-86", dateString = "Newgrowth 86")
        Log_2025_04_05_Day_2()
        SessionDayHeader(dayId = "newgrowth-87", dateString = "Newgrowth 87")
        Log_2025_04_05_Day_3()
    }
}
